import { Badge, Select } from '@mantine/core'

import { useQuery } from '@redwoodjs/web'

import { GET_COURSES } from 'src/graphql/trainings.graphql'

import { inlineSelectProps } from './inlineSelectStyles'

const CourseOptions = ({ selectedCourse, setSelectedCourse }) => {
  const { data: courses } = useQuery(GET_COURSES)

  const courseList =
    courses?.courses?.items?.map((course) => ({
      value: course.courseId,
      label: course.name,
      provider: course.provider,
    })) || []

  return (
    <div className="flex flex-col gap-3 text-xs">
      {courseList.length === 0 ? (
        <div className="text-xs text-doubleNickel-gray-500">
          No courses found.
        </div>
      ) : (
        <Select
          {...inlineSelectProps}
          value={selectedCourse?.courseId}
          onChange={(value) => setSelectedCourse({ courseId: value })}
          data={courseList}
          className="max-w-sm"
          searchable
          renderOption={({ option }: any) => (
            <div className="flex items-center justify-between w-full gap-2">
              <span>{option.label}</span>
              <Badge
                size="xs"
                variant="light"
                color={option.provider === 'LUMA' ? 'orange' : 'blue'}
              >
                {option.provider === 'LUMA' ? 'Luma' : 'Trainix'}
              </Badge>
            </div>
          )}
        />
      )}
    </div>
  )
}

export default CourseOptions
